import React from 'react';
import {connect} from 'react-redux'
import Paper from 'material-ui/Paper';

import { isDirty } from 'redux-form'

import * as colors from 'material-ui/styles/colors';

import PageBase from '../../../components/PageBase';

import gStyles from '../../../styles'

import * as actions from '../../../actions'
import SubHolidayMasterForm from './SubHolidayMasterForm'
import _ from 'lodash'

class SubHolidayMasterPage extends React.PureComponent {

  constructor(props) {
    super(props)
    this.state = {
      init: false,
    }
  }

  componentWillReceiveProps(nextProps) {

    if (nextProps.auth) {

      if (!_.isEqual(this.props.auth.user, nextProps.auth.user)) {
        if (!this.state.init) {
          this.setState({init: true})
          this.initRoumu(nextProps.auth.user)
        }
      }

    }
  }

  componentDidMount() {
    window.scrollTo(0, 0)

    this.initRoumu(this.props.auth.user)

    this.unblock = this.props.history.block((location, action) => {
      if (this.props.dirty) {
        return '入力した情報は保存されません。よろしいですか？'
      }
    })

  }

  initRoumu(user) {

    if (!user || !user.id) {
      return
    }

    const {
      match,
      handleInit
    } = this.props

    let userId
    if (match.params.userId && (user.permission == 2 || user.permission == 3)) {
      userId = match.params.userId
    } else {
      userId = user.id
    }
 
    this.setState({init: true})
    handleInit(userId)

  }

  componentWillUnmount() {
    this.unblock()
  }

  render() {

    const {
      auth,
      match,
      form,
      count,
      history,
      handleRegist,
    } = this.props

    const backDate = match.params.backDate;
    const userId = match.params.userId || auth.user.id
    let userName = match.params.userName || auth.user.name
    if (userName) {
      userName = decodeURI(userName)
    }

    let otherUserEdit = false
    if (match.params.userId) {
      otherUserEdit = true
    }

    return (

      <PageBase title={`代休管理（${userName ? userName : ''}） 【代休残日数】：${count || count == 0? count : ''}日`}>

        <div>

          <Paper style={{...gStyles.searchBoxContainer}}>
            <SubHolidayMasterForm 
              auth={auth}
              userId={userId}
              backDate={backDate}
              history={history}
              initialValues={form}
              onRegist={handleRegist(userId)}
              otherUserEdit={otherUserEdit}
            />
          </Paper>

        </div>

      </PageBase>

    )
  }

}

const mapStateToProps = (state) => ({
  auth: state.auth,
  form: state.subHoliday.form,
  count: state.subHoliday.count,
  dirty: isDirty('subHolidayMasterForm')(state),
})

const mapStateToDispatch = (dispatch) => ({
  handleInit : (userId) => {dispatch(actions.systemSubHolidayInit(userId))},
  handleRegist : (userId) => (form) => {
    dispatch(actions.userSubHolidayRegist(userId, form))
  },
})

SubHolidayMasterPage = connect(
  mapStateToProps,
  mapStateToDispatch
)(SubHolidayMasterPage)

export default SubHolidayMasterPage;



// WEBPACK FOOTER //
// ./src/containers/master/subHoliday/SubHolidayMasterPage.js